import React, { useState } from 'react';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';
import useAIToolsCanvasStore, {
  clampAIToolsZoomPercent,
  handleZoom,
  handleFitScreen,
} from '@/store/useAIToolsCanvasStore';
import style from './index.module.scss';

/**
 * 画布底部缩放工具栏
 * 缩小 | 缩放百分比 | 放大 | 适应屏幕
 */
export default function CanvasToolbar() {
  const languageStore = useLanguageStore((state) => state.languageStore);
  const { zoomNum, render } = useAIToolsCanvasStore((state) => ({
    zoomNum: state.zoomNum,
    render: state.render,
  }));
  const [inputFocus, setInputFocus] = useState<boolean>(false);
  const [zoomInput, setZoomInput] = useState<string>(''); // 输入框显示的内容

  // 失焦时把手动输入的缩放值应用到画布，并限制在 5%-400%。
  const onBlurZoom = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputFocus(false);
    const { value } = e.target as HTMLInputElement;
    const numValue = Number(value);
    if (!Number.isNaN(numValue)) {
      const currentValue = clampAIToolsZoomPercent(numValue);
      render?._FC.fire('viewport:zoom', { zoom: currentValue / 100 });
      render?.setZoom(currentValue / 100);
    }
  };

  // 输入阶段只保留百分比数字，最终范围在失焦时统一收敛。
  const onChangeZoom = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^\d{0,3}$/;
    const { value } = e.target as HTMLInputElement;
    if (regex.test(value)) {
      setZoomInput(value);
    }
  };

  return (
    <div className={style.canvas_toolbar}>
      <div
        className={style.zoom_btn}
        onClick={() => handleZoom(-5)}
      >
        <IconFont name="zoomOutBold" fontSize={20} color="var(--content-buttonSecondary)" />
      </div>

      <div className={style.zoom_box_wrapper}>
        <div
          className={`${style.zoom_box} ${inputFocus ? style.zoom_box_focus : ''}`}
        >
          <input
            type="text"
            value={inputFocus ? zoomInput : Math.round(zoomNum)}
            onChange={onChangeZoom}
            onFocus={() => {
              setZoomInput(Math.round(zoomNum).toString());
              setInputFocus(true);
            }}
            onBlur={onBlurZoom}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                (e.target as HTMLInputElement).blur();
              }
            }}
          />
        </div>
        <div className={style.suffix}>%</div>
      </div>

      <div
        className={style.zoom_btn}
        onClick={() => handleZoom(5)}
      >
        <IconFont name="zoomInBold" fontSize={20} color="var(--content-buttonSecondary)" />
      </div>

      <div
        className={style.fit_screen_btn}
        onClick={() => handleFitScreen()}
      >
        <IconFont name="fullScreenBold" fontSize={16} color="var(--content-buttonSecondary)" />
        <span>{languageStore.smartcatTranslationText((v) => v.adapt_to_screen)}</span>
      </div>
    </div>
  );
}
